import { IPartnerMarketLeasing } from 'legacy/lut/features/partner360/marketInfo'

import { jbpMarketLeasingDataSource } from './configs'
import { getJBPMarketLeasingCrud } from './helpers/getJBPMarketLeasingCrud'
import { mapMarketLeasingTo1018 } from './mappings/mapMarketLeasingTo1018'
import { IJBPMarketLeasingCrudParams } from './models'

export const createPartnerMarketLeasing = async (
  params: IJBPMarketLeasingCrudParams,
  formData: Omit<IPartnerMarketLeasing, 'entryId'>
) => {
  const marketLeasingCrud = getJBPMarketLeasingCrud(params)

  const mappedData = mapMarketLeasingTo1018({
    ...params,
    ...formData,
  })

  const [createdItem] = await marketLeasingCrud.create(jbpMarketLeasingDataSource, [mappedData])
  return createdItem
}
